import React from "react";
//import DocHubHero from "./DocHubHero.jsx";
import DocHubHero from "./DocHubHero-with-kapa.jsx";
import ProductCards from "./ProductCards.jsx";
import FeatureGrid from "./FeatureGrid.jsx";
import "../../../static/styles.css";
import GettingStarted from "./GettingStarted.jsx";
import ResourcesSection from "./ResourcesSection.jsx";

function DocHub() {
  debugger
  return (
    <div>
        <DocHubHero />
        <ProductCards />
        <FeatureGrid />
        <ResourcesSection />
    </div>
  );
}

export default DocHub;
